(() => {
  if (customElements.get('product-shelf')) return;

  class ProductShelf extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.stickyReturn = this.querySelector('[data-sticky-return]');
      this.trigger = document.getElementById(this.dataset.stickyTriggerId);
      this.isShelfVisible = true;
      this.hasPassedTrigger = false;

      this.querySelectorAll('[data-variant-select]').forEach(select => {
        select.addEventListener(
          'change',
          () => this.updateVariant(select),
          { signal: this.abortController.signal }
        );
      });

      if (!this.stickyReturn || !this.trigger) return;

      this.stickyReturn.hidden = false;
      this.stickyReturn.setAttribute('aria-hidden', 'true');
      this.stickyReturn.setAttribute('tabindex', '-1');

      this.shelfObserver = new IntersectionObserver(entries => {
        this.isShelfVisible = entries[0].isIntersecting;
        this.updateStickyReturn();
      });

      this.triggerObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.hasPassedTrigger = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        this.updateStickyReturn();
      });

      this.shelfObserver.observe(this);
      this.triggerObserver.observe(this.trigger);
      this.mobileQuery.addEventListener(
        'change',
        () => this.updateStickyReturn(),
        { signal: this.abortController.signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.shelfObserver?.disconnect();
      this.triggerObserver?.disconnect();
    }

    updateVariant(select) {
      const option = select.options[select.selectedIndex];
      const card = select.closest('[data-product-card]');
      if (!option || !card) return;

      const currentPrice = card.querySelector('[data-current-price]');
      const compareAt = card.querySelector('[data-compare-at]');
      const button = card.querySelector('[data-add-to-cart]');
      const isAvailable = option.dataset.available === 'true';

      if (currentPrice) currentPrice.textContent = option.dataset.price;

      if (compareAt) {
        compareAt.textContent = option.dataset.compareAt;
        compareAt.hidden = !option.dataset.compareAt;
      }

      if (button) {
        button.disabled = !isAvailable;
        button.textContent = isAvailable
          ? button.dataset.availableLabel
          : button.dataset.soldOutLabel;
      }
    }

    updateStickyReturn() {
      if (!this.stickyReturn) return;

      const shouldShow = this.mobileQuery.matches && this.hasPassedTrigger && !this.isShelfVisible;
      this.stickyReturn.dataset.visible = String(shouldShow);
      this.stickyReturn.setAttribute('aria-hidden', String(!shouldShow));
      this.stickyReturn.setAttribute('tabindex', shouldShow ? '0' : '-1');
    }
  }

  customElements.define('product-shelf', ProductShelf);
})();
